import { useEffect, useState } from "react";
import { api } from "@/lib/api";

const SUBJECTS = [
  { id: "all", label: "All" },
  { id: "physics", label: "Physics" },
  { id: "gen-chem", label: "Gen Chem" },
  { id: "biochemistry", label: "Biochem" },
  { id: "math", label: "Math" },
];

export default function Equations() {
  const [items, setItems] = useState([]);
  const [subject, setSubject] = useState("all");

  useEffect(() => {
    const params = subject === "all" ? {} : { subject };
    api.get("/equations", { params }).then((r) => setItems(r.data));
  }, [subject]);

  const grouped = items.reduce((acc, e) => {
    (acc[e.category] = acc[e.category] || []).push(e);
    return acc;
  }, {});

  return (
    <div className="max-w-5xl mx-auto" data-testid="equations-page">
      <h1 className="font-display text-4xl font-bold mb-3">Equation Sheet</h1>
      <p className="text-lg mb-6" style={{ color: "var(--text-secondary)" }}>
        Every equation you need on MCAT test day, in one place.
      </p>

      <div className="flex flex-wrap gap-2 mb-8" data-testid="eq-subject-tabs">
        {SUBJECTS.map((s) => (
          <button
            key={s.id}
            onClick={() => setSubject(s.id)}
            className="px-4 py-1.5 rounded-full text-sm font-medium"
            style={{
              background: subject === s.id ? "var(--primary)" : "var(--muted)",
              color: subject === s.id ? "white" : "var(--text)",
            }}
            data-testid={`eq-tab-${s.id}`}
          >
            {s.label}
          </button>
        ))}
      </div>

      <div className="space-y-8">
        {Object.entries(grouped).map(([cat, list]) => (
          <div key={cat} data-testid={`eq-cat-${cat.toLowerCase().replace(/[^a-z0-9]+/g,'-')}`}>
            <h2 className="font-display text-2xl font-bold mb-3">{cat}</h2>
            <div className="grid md:grid-cols-2 gap-3">
              {list.map((e, i) => (
                <div key={i} className="pm-card p-5" data-testid={`eq-item-${e.subject}-${i}`}>
                  <div className="text-xs uppercase tracking-widest font-semibold mb-1" style={{ color: "var(--text-muted)" }}>
                    {e.name}
                  </div>
                  <div className="font-mono text-lg font-semibold py-2" style={{ color: "var(--primary)" }}>
                    {e.formula}
                  </div>
                  {e.vars && <div className="text-xs mt-1" style={{ color: "var(--text-secondary)" }}>{e.vars}</div>}
                </div>
              ))}
            </div>
          </div>
        ))}
        {items.length === 0 && (
          <div className="text-sm" style={{ color: "var(--text-muted)" }}>Loading…</div>
        )}
      </div>
    </div>
  );
}
